import React from "react";

type SvgComponentProps = {
  type: string;
}
const SVGComponent = (props: SvgComponentProps) => {
  if (props.type === "close") {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
        <path
          id="icon_close"
          d="M10.875,10l8.938-8.937a.6.6,0,0,0,0-.875.6.6,0,0,0-.875,0L10,9.125,1.063.188a.6.6,0,0,0-.875,0,.6.6,0,0,0,0,.875L9.125,10,.187,18.938a.6.6,0,0,0,0,.875A.567.567,0,0,0,.625,20a.567.567,0,0,0,.438-.187L10,10.875l8.937,8.938a.6.6,0,0,0,.875,0,.6.6,0,0,0,0-.875Z"
          fill="#fff"
        />
      </svg>
    );
  }

  if (props.type === "map-marker-line") {
    return (
      <svg
        id="icon_current_location"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <rect
          id="Rectangle_2401"
          data-name="Rectangle 2401"
          width="24"
          height="24"
          fill="rgba(0,149,218,0.3)"
          opacity="0"
        />
        <g
          id="Path_11601"
          data-name="Path 11601"
          transform="translate(-0.545 1)"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path
            d="M12.544,1a7.826,7.826,0,0,0-8,7.638c0,5.781,8,12.364,8,12.364s8-6.583,8-12.364A7.826,7.826,0,0,0,12.544,1Z"
            stroke="none"
          />
          <path
            d="M 12.54446220397949 0.9999980926513672 C 8.125911712646484 0.9999980926513672 4.544002532958984 4.419696807861328 4.544002532958984 8.638157844543457 C 4.544002532958984 14.41944694519043 12.54446220397949 21.00215721130371 12.54446220397949 21.00215721130371 C 12.54446220397949 21.00215721130371 20.544921875 14.41944694519043 20.544921875 8.638157844543457 C 20.544921875 4.419696807861328 16.9630126953125 0.9999980926513672 12.54446220397949 0.9999980926513672 M 12.54446220397949 -1.9073486328125e-06 C 17.50733184814453 -1.9073486328125e-06 21.544921875 3.875057220458984 21.544921875 8.638157844543457 C 21.544921875 14.82055759429932 13.52139186859131 21.49333763122559 13.17983245849609 21.77436828613281 C 12.99526214599609 21.92622756958008 12.76986217498779 22.00215721130371 12.54446220397949 22.00215721130371 C 12.31906223297119 22.00215721130371 12.09366226196289 21.92622756958008 11.90909194946289 21.77436828613281 C 11.56753253936768 21.49333763122559 3.544002532958984 14.82055759429932 3.544002532958984 8.638157844543457 C 3.544002532958984 3.875057220458984 7.581592559814453 -1.9073486328125e-06 12.54446220397949 -1.9073486328125e-06 Z"
            stroke="none"
            fill="#0095da"
          />
        </g>
        <g
          id="Ellipse_632"
          data-name="Ellipse 632"
          transform="translate(10 8)"
          fill="none"
          stroke="#0095da"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1"
        >
          <circle cx="2" cy="2" r="2" stroke="none" />
          <circle cx="2" cy="2" r="2.5" fill="none" />
        </g>
      </svg>
    );
  }

  if (props.type === "map-marker-solid") {
    return (
      <svg
        id="icon_location"
        data-name="icon/location"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <rect
          id="Rectangle_2901"
          data-name="Rectangle 2901"
          width="24"
          height="24"
          fill="none"
          opacity="0.272"
        />
        <path
          id="Subtraction_7"
          data-name="Subtraction 7"
          d="M8,20H8a35.035,35.035,0,0,1-4-4.014c-1.825-2.161-4-5.364-4-8.35A7.834,7.834,0,0,1,8,0a7.835,7.835,0,0,1,8,7.638c0,2.986-2.175,6.189-4,8.35A35.724,35.724,0,0,1,8,20ZM8,6a2,2,0,1,0,2,2A2,2,0,0,0,8,6Z"
          transform="translate(3.999 2)"
          fill="#fff"
        />
      </svg>
    );
  }

  if (props.type === "select-arrow") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        id="Capa_1"
        x="0px"
        y="0px"
        viewBox="0 0 490 490"
      >
        <g>
          <g>
            <path d="M490,474.459H0L245.009,15.541L490,474.459z" />
          </g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
          <g></g>
        </g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
        <g></g>
      </svg>
    );
  }

  if (props.type === "drop-down-arrow") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 11.219 22.409"
        className="drop-down-arrow"
      >
        <path
          id="icon_right"
          d="M3.115,27.006,13.127,16.5,3.115,6.011"
          transform="translate(-2.408 -5.304)"
        />
      </svg>
    );
  }

  if (props.type === "right-arrow") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="11.219"
        height="22.409"
        viewBox="0 0 11.219 22.409"
      >
        <path
          id="icon_right"
          d="M3.115,27.006,13.127,16.5,3.115,6.011"
          transform="translate(-2.408 -5.304)"
          fill="none"
          stroke="#0095da"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
      </svg>
    );
  }

  if (props.type === "spanner") {
    return (
      <svg
        id="icon_spanner"
        data-name="icon/spanner"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <rect
          id="Rectangle_2901"
          data-name="Rectangle 2901"
          width="24"
          height="24"
          fill="none"
          opacity="0.272"
        />
        <path
          id="Path_11625"
          data-name="Path 11625"
          d="M16.888,5.112l-.561-2.056,1.905-1.905a3.83,3.83,0,0,0-4.651,5.025L6.175,13.581a3.83,3.83,0,0,0-5.025,4.651l1.905-1.905,2.056.561.561,2.056L3.767,20.849a3.83,3.83,0,0,0,4.651-5.025l7.406-7.406a3.83,3.83,0,0,0,5.025-4.651L18.944,5.673Z"
          transform="translate(1 1)"
          fill="#fff"
        />
      </svg>
    );
  }

  if (props.type === "search") {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20.001">
        <g id="icon_search_24px" transform="translate(-351 -308.999)">
          <rect
            id="Rectangle_3410"
            data-name="Rectangle 3410"
            width="20"
            height="20"
            transform="translate(351 309)"
            fill="#8a72f0"
            opacity="0"
          />
          <path
            id="search_20x20"
            d="M19.771,18.908l-4.619-4.615a8.765,8.765,0,0,0,2-4.365A8.647,8.647,0,0,0,.046,7.37a8.689,8.689,0,0,0,7.3,9.791,9.39,9.39,0,0,0,1.248.125A8.534,8.534,0,0,0,13.716,15.6c.187-.125.312-.249.5-.374l4.619,4.615a.6.6,0,0,0,.874,0A.629.629,0,0,0,19.771,18.908Zm-6.742-4.365a7.215,7.215,0,0,1-5.493,1.372A7.463,7.463,0,0,1,1.294,7.557a7.425,7.425,0,0,1,7.3-6.3,6.062,6.062,0,0,1,1.061.062A7.59,7.59,0,0,1,14.528,4.19,7.2,7.2,0,0,1,15.9,9.678,7.191,7.191,0,0,1,13.029,14.542Z"
            transform="translate(351.045 308.969)"
            fill="#fff"
          />
        </g>
      </svg>
    );
  }

  return null;
}

export default SVGComponent;
